// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Elementos
    const $section = $('#vsl');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['vsl-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Elementos
    const $section = $('#vsl');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['vsl-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--vsl-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// TEXTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Elementos
    const $section = $('#vsl');
    const $secTitle = $('.vsl-titulo');
    const $secText = $('.vsl-texto');
    const $secText2 = $('.vsl-texto2 .md-text');

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['titulo'];
      $secTitle.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'titulo', changeTitle);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['vsl-tit-color'];
      $section[0].style.setProperty('--vsl-tit-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['texto'];
      $secText.html(fmtTxt(value));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto', changeText);

    // Altera o texto2
    function changeText2() {
      const value = confTheme[ref2]['texto2'];
      $secText2.html(fmtTxt(value));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'texto2', changeText2);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['vsl-txt-color'];
      $section[0].style.setProperty('--vsl-txt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      $section[0].style.setProperty('--txt-alt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

    // Altera a cor de fundo do texto
    function changeTxtBgColor() {
      const color = confTheme[ref]['txt-bg-color'];
      $section[0].style.setProperty('--txt-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
  }
})();

// ------------------------------------
// VÍDEO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Elementos
    const $section = $('#vsl');

    // Altera o border radius do vídeo
    function changeVideoBorderRadius() {
      const value = confTheme[ref]['video-border-radius'];
      $section[0].style.setProperty('--video-border-radius', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-border-radius', changeVideoBorderRadius);

    // Altera a largura da borda do vídeo
    function changeVideoBorderWidth() {
      const value = confTheme[ref]['video-border-width'];
      $section[0].style.setProperty('--video-border-width', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-border-width', changeVideoBorderWidth);

    // Altera a cor da borda do vídeo
    function changeVideoBorderColor() {
      const color = confTheme[ref]['video-border-color'];
      $section[0].style.setProperty('--video-border-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-border-color', changeVideoBorderColor);

    // Altera a largura da sombra do vídeo
    function changeVideoShadowSize() {
      changeVideoShadow();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-shadow-size', changeVideoShadowSize);

    // Altera a opacidade da sombra do vídeo
    function changeVideoShadowOpacity() {
      changeVideoShadow();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-shadow-opacity', changeVideoShadowOpacity);

    // Altera a cor da sombra do vídeo
    function changeVideoShadowColor() {
      changeVideoShadow();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'video-shadow-color', changeVideoShadowColor);

    // Altera a sombra do vídeo
    function changeVideoShadow() {
      let videoShadow = 'none';
      if (confTheme[ref]['video-shadow-size'] != 'none' && confTheme[ref]['video-shadow-size'] != '') {
        videoShadow = generateBoxShadown(
          confTheme[ref]['video-shadow-color'],
          confTheme[ref]['video-shadow-opacity'],
          confTheme[ref]['video-shadow-size'],
        );
      }
      $section[0].style.setProperty('--video-shadow', videoShadow);
    }
  }
})();

// ------------------------------------
// BOTÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Elementos
    const $secButton = $('.vsl-botao');

    // Oculta/Exibe o botão
    function changeBtnShow() {
      const value = confTheme[ref2]['btn-show'];
      value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-show', changeBtnShow);

    // Altera a classe do botão
    function changeBtnClass() {
      const value = confTheme[ref2]['btn-class'];
      const styleClass = confTheme['general'][value + '-style'];
      const AnimationClass = confTheme['general'][value + '-animation'];
      $secButton
        .find('.btn')
        .removeClass(btnClassesRem)
        .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnText() {
      const value = confTheme[ref2]['btn-text'];
      $secButton.find('.btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);

    // Oculta/Exibe o selo
    function changeSealShow() {
      const value = confTheme[ref2]['seal-show'];
      value == '1'
        ? $secButton.find('.btn-selos').removeClass('d-none')
        : $secButton.find('.btn-selos').addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'vsl-var';
    const ref2 = 'vsl';
    const refEvtPrefix = 'lp-evt-vsl-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('.vsl .section-divider').addClass('d-none');
      if (value) {
        $('.vsl .section-divider.' + value).removeClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      $('#vsl')[0].style.setProperty('--divisor-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();
